/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_EmptyInputs */

const en_ticket_empty = /** @type {(inputs: Ticket_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tickets found`)
};

const ja_ticket_empty = /** @type {(inputs: Ticket_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チケットが見つかりません`)
};

const fr_ticket_empty = /** @type {(inputs: Ticket_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun ticket trouvé`)
};

const de_ticket_empty = /** @type {(inputs: Ticket_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Tickets gefunden`)
};

/**
* | output |
* | --- |
* | "No tickets found" |
*
* @param {Ticket_EmptyInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_empty = /** @type {((inputs?: Ticket_EmptyInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_EmptyInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_empty(inputs)
	if (locale === "ja") return ja_ticket_empty(inputs)
	if (locale === "fr") return fr_ticket_empty(inputs)
	return de_ticket_empty(inputs)
});